import { useDarkMode } from "@/hooks/useDarkMode";
import { cn } from "@/lib/utils";

const WideButton = (props: {
  disabled?: boolean;
  onClick: () => void;
  className?: string;
  children?: any;
  type?: "filled" | "outlined";
}) => {
  const isDark = useDarkMode();
  const outlined = props.type === "outlined";
  return (
    <button
      disabled={props.disabled}
      style={{
        backgroundColor: props.disabled
          ? isDark
            ? "#313A71"
            : "#767586"
          : isDark
            ? outlined
              ? "#19165C"
              : "#4640BE"
            : outlined
              ? "#A39FE8"
              : "#19165C",
        borderWidth: outlined ? 2 : 0,
        borderColor: isDark ? "#A39FE8" : "#19165C",
      }}
      className={cn(
        "w-full",
        props.disabled
          ? "px-6 py-3 rounded-xl text-white dark:text-primary-800 text-base font-semibold leading-normal bg-neutral-300 dark:bg-neutral-500"
          : "px-6 py-3 rounded-xl text-white dark:text-primary-800 text-base font-semibold leading-normal bg-primary-800 dark:bg-primary-300",
        props.className
      )}
      onClick={props.onClick}
    >
      <span
        style={{
          color: isDark
            ? outlined
              ? "#FFF"
              : "#fff"
            : outlined
              ? "#19165C"
              : "#FFF",
        }}
        className="text-center text-white dark:text-primary-800 mobile-h3-small-semi-bold"
        aria-label={props.children}
      >
        {props.children}
      </span>
    </button>
  );
};

export default WideButton;
